// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post } from '../../../../common/api'
import { TASKBOARD_LIST } from '../../../../common/constant'

export const actionTaskBoard = createAsyncThunk('appTaskBoard/actionTaskBoard', async (params, thunkAPI) => {
    return await post(TASKBOARD_LIST, params, thunkAPI)
})

export const appTaskBoardSlice = createSlice({
    name : 'appTaskBoard',
    initialState:{

        //list
        loading: false,
        taskBoard: null
    },
    reducers:{
        resetTaskBoardResponse: (state) => {
            state.taskBoard = null
        }
    },
    extraReducers: builder => {
        builder

        //list
        .addCase(actionTaskBoard.pending, (state) => {
            state.loading = true
        })
        .addCase(actionTaskBoard.fulfilled, (state, action) => {
            state.loading = false
            state.taskBoard = action.payload
        })
        .addCase(actionTaskBoard.rejected, (state) => {
            state.loading = false
        })

    }
})
export const { resetTaskBoardResponse } = appTaskBoardSlice.actions
export default appTaskBoardSlice.reducer